import { Box } from '@lingoda/ui';
import { styled } from '@lingoda/ui/theme';

export const Container = styled(Box)(({ theme }) => ({
    width: '100%',
    maxWidth: 370,
    margin: 'auto',
    padding: theme.spacing(0, 3),
}));
